<script setup>
  import ListeDemandes from '@/components/ListeDemandes.vue'

</script>

<template>
  <h1>Liste des demandes</h1>
  <div class="demandes">

    <ListeDemandes/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
